import React, { useState } from 'react'
import { authAPI } from '../api/client'

export const PasswordReset: React.FC = () => {
  // A fragment never reaches access logs or the server's Referer header.
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get('token') || '')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const [complete, setComplete] = useState(false)
  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      const result = token
        ? await authAPI.confirmPasswordReset(token, password)
        : await authAPI.requestPasswordReset(email)
      setMessage(result.message)
      setComplete(true)
      if (token) window.history.replaceState(null, '', window.location.pathname)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to reset password')
    } finally { setBusy(false) }
  }
  return <main className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
    <form onSubmit={submit} className="w-full max-w-md space-y-4 p-6 dark:text-gray-100">
      <h1 className="text-2xl font-bold">Reset your password</h1>
      {!complete && <>
        <label htmlFor="reset-value">{token ? 'New password' : 'Email address'}</label>
        <input id="reset-value" className="block w-full rounded border p-3 text-gray-900" required
          type={token ? 'password' : 'email'} autoComplete={token ? 'new-password' : 'email'}
          value={token ? password : email} minLength={token ? 12 : undefined}
          onChange={e => token ? setPassword(e.target.value) : setEmail(e.target.value)} />
        <button disabled={busy} className="rounded bg-blue-600 text-white px-4 py-2">
          {busy ? 'Please wait…' : token ? 'Set password' : 'Send reset link'}
        </button>
      </>}
      {message && <p role="status">{message}</p>}
      {error && <p role="alert">{error}</p>}
      <a className="block text-blue-600" href="/login">Return to sign in</a>
    </form>
  </main>
}
